// HARDCODE
export default {
  DEFAULT_TERRITORY_OOPT_ID: 'e5498be5-b1ce-c1a9-03be-fe01cfa2c0c1',
  DEFAULT_TERRITORY_OOPT_NAME: 'Прибайкальский национальный парк',
  DEFAULT_TERRITORY_OOPT_NAME_CASE: 'Прибайкальского НП',
};
